// ============================================================
// 生成 Schema（阶段一 T1）：3D+2D 融合（dtwince.fusion.schema.json）
// 落库映射：pages.sceneId + pages.sceneAnchor + scene_data_binding
// ============================================================
import { z } from 'zod';
import { GENERATION_SCHEMA_VERSION, GEN_LIMITS, VISUAL_TYPES } from './constants';

/** 锚点坐标（pages.scene_anchor 的 SceneAnchor 使用对象形式 {x,y,z}） */
export const anchorVec3Schema = z.object({ x: z.number(), y: z.number(), z: z.number() }).strict();
export type AnchorVec3 = z.infer<typeof anchorVec3Schema>;

/** 大屏锚点（pages.scene_anchor，SceneAnchor 对齐） */
export const sceneAnchorSchema = z
  .object({
    position: anchorVec3Schema,
    rotation: anchorVec3Schema,
    scale: z.number().positive().max(100).default(1),
    visible: z.boolean().default(true),
  })
  .strict();
export type SceneAnchorSpec = z.infer<typeof sceneAnchorSchema>;

/** 模型节点 ↔ 设备/点位/数据集绑定（scene_data_binding） */
export const fusionBindingSchema = z
  .object({
    /** 模型引用键：生成时为 "model:{index}"，写库后由 DraftWriter 映射为 models.id */
    modelNodeId: z.string().min(1).max(128),
    modelNodeName: z.string().max(128).optional(),
    deviceId: z.string().max(64).optional(),
    bindPointKey: z.string().max(64).optional(),
    dataSetId: z.string().max(64).optional(),
    visualType: z.enum(VISUAL_TYPES),
    ruleConfig: z.record(z.unknown()).default({}),
  })
  .strict();
export type FusionBindingSpec = z.infer<typeof fusionBindingSchema>;

export const fusionBundleSchema = z
  .object({
    schemaVersion: z.literal(GENERATION_SCHEMA_VERSION),
    kind: z.literal('fusion'),
    /** 引用同一批次生成的大屏（V1 固定 dashboard:0） */
    pageRef: z.string().max(64).default('dashboard:0'),
    sceneAnchor: sceneAnchorSchema,
    bindings: z.array(fusionBindingSchema).max(GEN_LIMITS.bindings).default([]),
  })
  .strict();

export type FusionBundle = z.infer<typeof fusionBundleSchema>;
